import ReactDOM from 'react-dom';
import * as captcha from './index';
import SMS from './sms';
import { VerifyType } from '@/utils/constants';

export default class VerifyCenter {
  options: VerifyOptions;
  sms?: SMS;
  onsuccess?: (result: any, type: VerifyType) => void;
  onclose?: (type: VerifyType) => void;
  constructor(props: VerifyOptions) {
    this.options = props;
    if (props.smsOptions) {
      this.sms = new SMS(props);
    }
  }

  render(desicionConf: string | Obj) {
    captcha.autoRender({
      commonOptions: this.options.commonOptions,
      captchaOptions: {
        ...this.options.captchaOptions,
        successCb: (result: any) => {
          this.options?.captchaOptions?.successCb?.(result);
          this.onsuccess?.(result, VerifyType.captcha);
        },
        closeCb: () => {
          this.options?.captchaOptions?.closeCb?.();
          this.onclose?.(VerifyType.captcha);
        },
      },
      secondVerifyWebOptions: {
        ...this.options.secondVerifyWebOptions,
        callBack: (res: any) => {
          this.options?.secondVerifyWebOptions?.callBack?.(res);
          this.onsuccess?.(res, VerifyType.secondVerify);
        },
        closeCallBack: () => {
          this.options?.secondVerifyWebOptions?.closeCallBack?.();
          this.onclose?.(VerifyType.captcha);
        },
      },
      verify_data: desicionConf,
    });
  }

  getFp() {
    // fp 前端获取逻辑： 用户传入 -> 取本地缓存/Cookie -> 重新生成
    return captcha.getCaptchaWebId(this.options.captchaOptions?.fp);
  }

  // close() {
  //   const root = document.getElementById(this.options.ele);
  //   if (root) {
  //     ReactDOM.unmountComponentAtNode(root);
  //   }
  // }
}
